<script setup lang="ts">
defineOptions({
	name: 'LiabilityAndWarrantiesSection',
})

const { t: $t, locale } = useI18n()
const { $tThird } = useNuxtApp()

const firstHtml = computed(() => {
	return $tThird(
		'{company} is not responsible for any losses that may arise from interferences, omissions, interruptions, computer viruses, malfunctions, or disconnections in the functioning of the electronic systems or in the devices and computer equipment of {users}, due to causes beyond our control. This includes delays or access blockages caused by deficiencies or overloads of the Internet or other electronic systems.',
		{
			users: `<span class="font-semibold">${$t('Users')}</span>`,
			company: '<span class="font-semibold">Gaveta Decimal</span>',
		},
	)
})

const secondHtml = computed(() => {
	return $tThird(
		'Furthermore, {company} is not liable for any use made by {users} of the content of the {platform} that may violate any national or international legislation concerning the protection of intellectual or industrial property rights or any other rights held by third parties. Specifically, each {user} is solely responsible for having communicated incorrect, false, or third-party information or data without their consent, as well as for the misuse of such information.',
		{
			users: `<span class="font-semibold">${$t('Users')}</span>`,
			user: `“<span class="italic">${$t('User')}</span>”`,
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
			company: '<span class="font-semibold">Gaveta Decimal</span>',
		},
	)
})

const thirdHtml = computed(() => {
	return $tThird(
		'{company} shall also not be held liable for any errors or omissions that may occur in the content of the {platform} or any other content accessible from it. To the extent permitted by applicable law, {company} cannot be held responsible for any damages arising from the use of the {platform} or for any actions taken based on the information provided therein.',
		{
			company: '<span class="font-semibold">Gaveta Decimal</span>',
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
		},
	)
})

const fourthHtml = computed(() => {
	return $tThird(
		'{users} hereby waive and absolve {company}, along with its parent company, subsidiaries, affiliates, and all their respective directors, officers, employees, agents, service providers, contractors, licensors, licensees, suppliers, and successors, from any and all claims arising from actions taken by us or any of the aforementioned parties in connection with investigations conducted by {company}, those parties, or law enforcement authorities.',
		{
			users: `<span class="font-semibold capitalize">${locale.value === 'fr' ? $t('the User') : $t('Users')}</span>`,
			company: '<span class="font-semibold">Gaveta Decimal</span>',
		},
	)
})

const fivethHtml = computed(() => {
	return $tThird(
		'Nevertheless, {company} declares that it has adopted and will continue to adopt all necessary measures, within its capabilities and current technological standards, to ensure the proper functioning of the {platform} and to prevent the existence and transmission of viruses and other harmful components to {users}.',
		{
			company: '<span class="font-semibold">Gaveta Decimal</span>',
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
			users: `<span class="font-semibold">${$t('Users')}</span>`,
		},
	)
})

const sixthHtml = computed(() => {
	return $tThird(
		'The {platform} may contain links, integrations, widgets, APIs, or other features that refer to third-party websites, applications, content, products, or services (“Third-Party Services”). Such Third-Party Services are operated by independent entities and are governed by their own terms and conditions and policies (including privacy and cookie policies), which the User must read and accept separately.',
		{
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
		},
	)
})

const seventhHtml = computed(() => {
	return $tThird(
		'{company} reserves the right to interrupt access to the {platform} at any time and without prior notice, whether for technical, security, control, maintenance, power supply failures, or any other reason. In any case, we will endeavour to restore access as soon as possible.',
		{
			company: '<span class="font-semibold">Gaveta Decimal</span>',
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
		},
	)
})

const eigthHtml = computed(() => {
	return $tThird('{company} does not control, validate, or assume any responsibility for', {
		company: '<span class="font-semibold">Gaveta Decimal</span>',
	})
})
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="i-ic:outline-account-balance"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $tThird('Liability and Warranties') }}
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p v-html="firstHtml"></p>
			<p v-html="secondHtml"></p>
			<p v-html="thirdHtml"></p>
			<p v-html="fourthHtml"></p>
			<p v-html="fivethHtml"></p>
			<p v-html="sixthHtml"></p>
			<p v-html="eigthHtml"></p>

			<ul class="list-disc pl-7 space-y-2.5">
				<li>
					{{
						$tThird(
							'The content, accuracy, lawfulness, quality, availability, security, or practices of Third-Party Services',
						)
					}};
				</li>
				<li>
					{{
						$tThird(
							'Any damages, losses, or liabilities arising from the User’s access to, use of, transactions with, communications with, or relationships with such third parties',
						)
					}}.
				</li>
			</ul>
			<p v-html="seventhHtml"></p>
		</div>
	</section>
</template>
